import { proxy, useSnapshot } from 'valtio'

/*
 * This file manages the state of whether live transcriptions are visible or not to producers and speakers.
 */
const liveTranscriptionsEnabledState = proxy<{ enabled: boolean }>({
  enabled: false,
})

const useAreLiveTranscriptionsEnabled = () =>
  useSnapshot(liveTranscriptionsEnabledState).enabled

const toggleLiveTranscriptions = () => {
  liveTranscriptionsEnabledState.enabled =
    !liveTranscriptionsEnabledState.enabled
}

export {
  liveTranscriptionsEnabledState,
  toggleLiveTranscriptions,
  useAreLiveTranscriptionsEnabled,
}
